export const getFileTypeByExtension = (extension) => {
	const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];

	return imageExtensions.includes(extension) ? 'IMAGE' : 'FILE';
}